import { render, staticRenderFns } from "./BaremeResultat.vue?vue&type=template&id=61df161a&scoped=true&"
import script from "./BaremeResultat.vue?vue&type=script&lang=js&"
export * from "./BaremeResultat.vue?vue&type=script&lang=js&"
import style0 from "./BaremeResultat.vue?vue&type=style&index=0&id=61df161a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61df161a",
  null
  
)

export default component.exports